export default function CTASection() {
  return (
    <section id="download" className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20dark%20gaming%20room%20with%20golden%20ambient%20lighting%2C%20elegant%20card%20table%20with%20playing%20cards%20and%20chips%2C%20warm%20crimson%20and%20gold%20tones%2C%20sophisticated%20casino%20atmosphere%2C%20no%20people%2C%20dramatic%20moody%20lighting&width=1800&height=800&seq=cta-bg-kaiyun&orientation=landscape"
          alt="下载开云棋牌"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/80 via-foreground-900/70 to-foreground-900/85"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold text-background-50 font-heading mb-4">
            立即下载<span className="text-accent-400">开云棋牌</span>
          </h2>
          <p className="text-background-50/70 text-sm md:text-base mb-8 md:mb-10 leading-relaxed">
            支持iOS、Android、PC多端下载，注册即送88888欢乐豆大礼包！
            <br className="hidden md:block" />
            首充双倍返利，每日签到领福利，邀请好友双方得奖励！
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-8">
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-accent-500 text-foreground-950 font-bold text-sm md:text-base hover:bg-accent-400 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-[0_4px_20px_rgba(200,160,50,0.4)]"
            >
              <i className="ri-apple-fill mr-2"></i>
              iOS 下载
            </a>
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 font-semibold text-sm md:text-base hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-android-fill mr-2"></i>
              Android 下载
            </a>
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 font-semibold text-sm md:text-base hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-computer-line mr-2"></i>
              PC 客户端
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-background-50/50 text-xs">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line"></i>
              正版授权
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-lock-line"></i>
              安全加密
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-refresh-line"></i>
              极速下载
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-gift-line"></i>
              新人礼包
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}